import { createFormHook, createFormHookContexts } from "@tanstack/react-form";

export const { fieldContext, formContext } = createFormHookContexts();

export const { useAppForm: useStaffForm, withForm: withStaffForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {},
  formComponents: {},
});
